import { render, staticRenderFns } from "./VideoCategoryForm.vue?vue&type=template&id=0de09472&"
import script from "./VideoCategoryForm.vue?vue&type=script&lang=js&"
export * from "./VideoCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports